import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './core/App';
import { AuthProvider } from './core/context/AuthContext';
import { EnterpriseConfigProvider } from './core/context/EnterpriseConfigContext';
import { TelemetryProvider } from './core/context/TelemetryContext';
import { CurriculumProvider } from './core/context/CurriculumContext';

// Get the root element from the HTML
const container = document.getElementById('root');

// Create a root
const root = createRoot(container);

// Render the main App component
root.render(
  <React.StrictMode>
    <AuthProvider>
      <EnterpriseConfigProvider>
        <TelemetryProvider>
          <CurriculumProvider>
            <App />
          </CurriculumProvider>
        </TelemetryProvider>
      </EnterpriseConfigProvider>
    </AuthProvider>
  </React.StrictMode>
);